import { Box, Button, Text } from '@instamenu/ui-system-next';
import { TimeInput } from '@instamenu/ui-system-next';
import { useLocale } from '@instamenu/context-i18n';

type Period = {
  startTime?: number | null;
  endTime?: number | null;
};

type TimePeriodInputProps = {
  period: Period;
  index: number;
  onStartTimeChange: (value?: number) => void;
  onEndTimeChange: (value?: number) => void;
  onAdd: () => void;
  onRemove: () => void;
  className?: string;
  disabled?: boolean;
};

export const TimePeriodInput = ({
  period,
  index,
  onStartTimeChange,
  onEndTimeChange,
  onAdd,
  onRemove,
  className,
  disabled = false,
}: TimePeriodInputProps) => {
  const { i18n } = useLocale();
  return (
    <Box className={className}>
      <TimeInput
        variant="sm"
        time={period.startTime ?? undefined}
        onChange={onStartTimeChange}
        disabled={disabled}
      />
      <Text css={{ marginTop: '10px' }}>{i18n.t('settings.restaurantSettings.to')}</Text>
      <TimeInput
        variant="sm"
        time={period.endTime ?? undefined}
        onChange={onEndTimeChange}
        disabled={disabled}
      />
      <Button
        type="button"
        variant="secondary"
        size="xs"
        onClick={() => (index === 0 ? onAdd() : onRemove())}
        disabled={disabled}
        css={{ marginTop: '10px' }}
      >
        {index === 0 ? '+' : '×'}
      </Button>
    </Box>
  );
};
